import styles from './DetailedGiveawayBanner.module.scss';
import { GiveawayDetailed } from '@/entities/giveaway/types';
import { LottieAnimation } from '@/components/LottieAnimation';
import rayWinnerAnimation from '@/assets/ray-lottie.json';

const DetailedGiveawayBanner = ({
  giveaway,
}: {
  giveaway: GiveawayDetailed;
}) => {
  return (
    <div
      style={{ backgroundImage: `url(${giveaway.background})` }}
      className={styles.banner}
    >
      <LottieAnimation
        animationData={rayWinnerAnimation}
        autoplay
        loop
        style={{
          position: 'absolute',
          top: '50%',
          transform: 'translate(0, -50%)',
        }}
      />
      <div className={styles.bannerPrize}>
        <img src={giveaway.prizes_image} alt="main_prize" />
      </div>
    </div>
  );
};

export default DetailedGiveawayBanner;
